import { Stack, Typography } from '@mui/material';
import React from 'react';
import { IInfoLine } from './interfaces';

export const InfoLine: React.FC<IInfoLine> = ({
  icon: Icon,
  text,
}): JSX.Element => {
  return (
    <Stack gap="3px" direction="row" alignItems="center">
      <Icon
        sx={{
          width: '15px',
          height: '15px',
          color: '#95a5a6',
        }}
      />
      <Typography variant="body2" color="text.secondary">
        {text}
      </Typography>
    </Stack>
  );
};
